import { render, staticRenderFns } from "./TicketTemplate.vue?vue&type=template&id=4f28ecdc&"
import script from "./TicketTemplate.vue?vue&type=script&lang=ts&"
export * from "./TicketTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./TicketTemplate.vue?vue&type=style&index=0&id=4f28ecdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports